module.exports = __webpack_public_path__ + "img/bounty.6251354a.png";